import React, { useState, useEffect } from "react";
import logoMapache from "./img/logo_mapache.png";
// import MainMenu from "./components/MainMenu";
import MainPage from "./pages/MainPage";

// import FilterComponent from "components/FilterComponent";

import "./App.css";
// import Main from "./components/Main";

function App() {
  const CURRENT_VERSION = "1.4.5"; // cambia esto manualmente en cada deploy

  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");
    if (storedVersion !== CURRENT_VERSION) {
      localStorage.setItem("app_version", CURRENT_VERSION);
      window.location.href =
        window.location.pathname + "?v=" + Date.now();
      window.location.reload(); // fuerza recarga con la nueva versión
    }
  }, []);

  const [loading, setLoading] = useState(true);
  // const [menuVisible, setMenuVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoading(false), 600); // Simula un tiempo de carga de 3 segundos
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loader-container d-flex flex-column justify-content-center align-items-center vh-100 text-center bg-light">
          <div className="logo-container bg-red">
            <img
              src={logoMapache}
              alt="Logo Mapache"
              className="logo-loader"
              style={{
                width: "40%",
                height: "auto",
              }}
            />
          </div>
          <h1 className="mt-3 text-white text-stroke">APP</h1>
          <h2 className="text-white text-stroke">P.U.E.S</h2>
          {/* <img src={logoMapache} alt="Logo" className="logo-loader" /> */}
          {/* <h3>App Pues</h3> */}
        </div>
      ) : (
        <div className="app-content">
          {/* Contenido principal de la app */}
          {/* Sidebar Menu */}

          {/* Main Content */}
          <MainPage />
        </div>
      )}
    </div>
  );
}

export default App;
